<template>
    <div>
        <!--登录-->
        <Modal v-model="modalStatus" width="24%" :mask-closable="false">
            <div slot="close" class="close-btn">
                <Icon
                    type="close-round"
                    @click="handleClose"
                    color="#5c6b77"
                    size="15"
                ></Icon>
            </div>
            <div class="login-header">登录</div>
            <Tabs
                v-model="activeTab"
                type="card"
                :animated="false"
                @on-click="handleTab"
            >
                <TabPane label="短信登录" name="1"></TabPane>
                <TabPane label="密码登录" name="2"></TabPane>
            </Tabs>

            <Form ref="loginForm" :model="loginParams" :rules="loginRuleInline">
                <FormItem prop="account">
                    <Input
                        v-model.trim="loginParams.account"
                        placeholder="请输入手机号码"
                        @keyup.enter.native="handleSubmit"
                    >
                        <Icon
                            type="android-phone-portrait"
                            slot="prepend"
                            size="16"
                            color="#5c6b77"
                        ></Icon>
                    </Input>
                </FormItem>

                <div
                    v-if="activeTab == 1"
                    style="display: flex; align-items: flex-start"
                >
                    <div style="flex: 1">
                        <FormItem prop="smsCode">
                            <Input
                                v-model.trim="loginParams.smsCode"
                                placeholder="请输入短信验证码"
                            >
                                <Icon
                                    type="android-textsms"
                                    slot="prepend"
                                    size="16"
                                    color="#5c6b77"
                                ></Icon>
                            </Input>
                        </FormItem>
                    </div>

                    <Button
                        type="primary"
                        style="margin-left: 3%"
                        :loading="sendCodeBtnDisabled"
                        @click="handleVerifyCodeBtn"
                    >
                        <span v-if="!sendCodeBtnDisabled">获取验证码</span>
                        <span v-else>{{ sendCodeTimeCount }}秒</span>
                    </Button>
                </div>

                <FormItem prop="password" v-if="activeTab == 2">
                    <Input
                        type="password"
                        v-model.trim="loginParams.password"
                        placeholder="请输入密码"
                        @keyup.enter.native="handleSubmit"
                    >
                        <Icon
                            type="locked"
                            slot="prepend"
                            size="16"
                            color="#5c6b77"
                        ></Icon>
                    </Input>
                </FormItem>

                <div class="resister-forget-pwd clear_fix">
                    <div>
                        <RadioGroup v-model="isBusinessRadio">
                            <Radio label="1">个人</Radio>
                            <Radio label="2">企业</Radio>
                        </RadioGroup>
                    </div>
                    <!-- <div
                        class="register-txt f_right"
                        @click="resetPasswordModalShow"
                    >
                        忘记密码?
                    </div> -->
                </div>
            </Form>
            <div slot="footer">
                <!--<Button @click="handleLoginCancel" class="login-btn">取消</Button>-->
                <Button
                    type="primary"
                    @click="handleSubmit"
                    class="login-btn"
                    long
                    >登录</Button
                >
            </div>
        </Modal>
        <!--滑动验证-->
        <verfy ref="verfy" @success="verifySuccess"></verfy>

        <!--滑动验证-->
        <verfyElse ref="verfyElse" @success="verifySuccessElse"></verfyElse>
    </div>
</template>
<script>
import { postSendSms } from "../api/user.js";
import verfy from "../components/Verify.vue";
import verfyElse from "../components/Verify.vue";
import mtils from "mtils";
export default {
    components: {
        verfy,
        verfyElse,
    },
    data() {
        //校验手机号码
        const validateMobile = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号码不能为空"));
            }
            if (!mtils.validation.isMobile(value)) {
                return callback(new Error("手机号码格式不正确"));
            }
            callback();
        };
        return {
            isBusinessRadio: "1",
            modalStatus: false,
            //登录信息
            loginParams: {
                account: "",
                password: "",
                smsCode: "",
                isBusiness: false,
            },
            sendCodeBtnDisabled: false,
            sendCodeTimeCount: 0,
            sendCodeTimer: null,
            //登录校验
            loginRuleInline: {
                account: [
                    {
                        required: true,
                        message: "手机号码不可为空",
                        trigger: "blur",
                    },
                    {
                        validator: validateMobile,
                        trigger: "blur",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "密码不可为空",
                        trigger: "blur",
                    },
                ],
                smsCode: [
                    {
                        required: true,
                        message: "验证码不可为空",
                        trigger: "blur",
                    },
                ],
            },

            activeTab: "1",
        };
    },
    watch: {
        modalStatus(val) {
            if (!val) {
                clearInterval(this.sendCodeTimer);
                this.sendCodeBtnDisabled = false;
                this.sendCodeTimeCount = 0;
                this.$refs["loginForm"].resetFields();
            }
        },
    },
    methods: {
        handleTab(val) {
            this.activeTab = val;
        },

        handleClose() {
            this.modalStatus = false;
            this.$store.dispatch("setLoginStatus", false);
            this.$refs["loginForm"].resetFields();
        },

        handleSubmit() {
            this.$refs["loginForm"].validate((valid) => {
                if (valid) {
                    if (this.activeTab == 2) {
                        this.$refs.verfyElse.Show();
                    } else {
                        if (this.isBusinessRadio == 1) {
                            this.loginParams.isBusiness = false;
                            this.$emit("postLogin", this.loginParams);
                        } else {
                            this.loginParams.isBusiness = true;
                            this.$emit("postLogin", this.loginParams);
                        }
                    }
                }
            });
        },

        async handleVerifyCodeBtn(rule, value, callback) {
            let patternAccount =
                /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/;
            if (!this.loginParams.account) {
                this.$Message.info("手机号码不可为空!");
            } else if (!patternAccount.test(this.loginParams.account)) {
                this.$Message.info("手机号码格式错误!");
            } else {
                this.$refs.verfy.Show();
            }
        },

        //验证码通过
        verifySuccessElse() {
            if (this.isBusinessRadio == 1) {
                this.loginParams.isBusiness = false;
                this.$emit("postLogin", this.loginParams);
            } else {
                this.loginParams.isBusiness = true;
                this.$emit("postLogin", this.loginParams);
            }
        },

        //验证码通过
        verifySuccess() {
            this.sendCodeBtnDisabled = true;
            this.sendCodeTimeCount = 60;
            postSendSms(this.loginParams.account).then((res) => {
                if (res.code == 200) {
                    this.sendCodeTimer = setInterval(() => {
                        this.sendCodeTimeCount = this.sendCodeTimeCount - 1;
                        if (this.sendCodeTimeCount < 0) {
                            this.sendCodeBtnDisabled = false;
                            clearInterval(this.sendCodeTimer);
                        }
                    }, 1000);
                } else {
                    this.$Message.error("验证码获取错误");
                }
            });
        },
    },
};
</script>
<style scoped>
.login-header {
    height: 98px;
    line-height: 98px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/ModalLogin.vue